var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.vendorId === -999)?_c('v-card',{staticClass:"ma-2"},[_c('v-card-title',{staticClass:"red--text"},[_vm._v("Input Data Pribadi terlebih dahulu")])],1):_c('PersonPengalamanContent',{attrs:{"vendorId":_vm.vendorId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }